export const CONNECTION_STATE = [ 'disconnected', 'connecting', 'connected' ] as const;
export type EConnectionState = typeof CONNECTION_STATE[number];
